import { Injectable } from '@angular/core';
import * as Papa from 'papaparse';

@Injectable({
    providedIn: 'root'
})
export class CsvParserService {
    constructor() {}

    parse(csvString: string, options: any = {}): any {
        const defaultOptions = {
            header: true,
            skipEmptyLines: true,
            dynamicTyping: true
        };

        const mergedOptions = { ...defaultOptions, ...options };
        return Papa.parse(csvString, mergedOptions);
    }
}
